import { BOOKSY_URL, INSTAGRAM_URL, NAV_LINKS } from "@/data/content";
import { Logo } from "@/components/Logo";

export const Footer = () => (
    <footer data-testid="footer" className="border-t border-white/10 bg-ink py-16">
        <div className="mx-auto flex max-w-7xl flex-col items-center px-4 text-center sm:px-6 lg:px-8">
            <Logo testId="footer-logo" className="h-20 w-auto" />

            <p data-testid="footer-tagline" className="mt-6 text-sm font-semibold text-gray-400">
                El cuidado que tu coche merece
            </p>

            <nav className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-testid="footer-nav">
                {NAV_LINKS.filter((l) => !["Reseñas", "Instagram"].includes(l.label)).map((link) => (
                    <a
                        key={link.href}
                        href={link.href}
                        data-testid={`footer-link-${link.label.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")}`}
                        className="text-sm font-semibold text-gray-300 transition-colors duration-200 hover:text-white"
                    >
                        {link.label}
                    </a>
                ))}
                <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-link-instagram"
                    className="text-sm font-semibold text-gray-300 transition-colors duration-200 hover:text-white"
                >
                    Instagram
                </a>
                <a
                    href={BOOKSY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-link-reservar"
                    className="text-sm font-semibold text-gray-300 transition-colors duration-200 hover:text-white"
                >
                    Reservar
                </a>
            </nav>

            <p className="mt-10 border-t border-white/10 pt-8 text-xs text-gray-500">
                © {new Date().getFullYear()} Autolavado Rey Detailing — C. Francisco Fernández
                Diez, 17, León
            </p>
        </div>
    </footer>
);
